// src/components/common/QRScannerButton.jsx

import React, { useState } from 'react';
import QRAccumulationFlow from './QRAccumulationFlow';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQrcode } from '@fortawesome/free-solid-svg-icons';

const QRScannerButton = ({
    onQRScanned,
    buttonText = "Escanear QR",
    className = "",
    productos = [],
    onAccumulateSuccess,
    useIntegratedFlow = true,
    tiendaId // ✅ NUEVO PARÁMETRO REQUERIDO
}) => {
    const [showFlow, setShowFlow] = useState(false);

    const handleAccumulateSuccess = (result) => {
        // Llamar al callback de éxito si existe
        if (onAccumulateSuccess) {
            onAccumulateSuccess(result);
        }

        // También llamar al callback original si existe
        if (onQRScanned) {
            onQRScanned(result);
        }
    };

    return (
        <>
            <button
                onClick={() => setShowFlow(true)}
                className={`inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors ${className}`}
            >
                <FontAwesomeIcon icon={faQrcode} />
                {buttonText}
            </button>

            {showFlow && (
                <QRAccumulationFlow
                    isOpen={showFlow}
                    onClose={() => setShowFlow(false)}
                    productos={productos}
                    onAccumulateSuccess={handleAccumulateSuccess}
                    tiendaId={tiendaId} // ✅ PASAR TIENDA ID
                />
            )}
        </>
    );
};

export default QRScannerButton;

